'use strict';

bbw.service.ChatUnreadCountSvc = Class({

    $inject: ['bbw.ChatSvc', '$rootScope', '$timeout', '$q'],

    CHAT_UNREAD_COUNT_UPDATED_EVENT: 'chat-unread-count-updated-event',

    _chatSvc: undefined,
    _count: undefined,
    _timeoutPromise: undefined,

    construct: function(chatSvc, $rootScope, $timeout, $q) {
        this._chatSvc = chatSvc;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$q = $q;
        this._init();
    },

    subscribe: function(cb, scope) {
        if (!scope) {
            scope = this.$rootScope;
        }
        scope.$on(this.CHAT_UNREAD_COUNT_UPDATED_EVENT, function(_, data) {
            cb(data.count);
        });
        angular.isDefined(this._count) && cb(this._count);
    },

    _emit: function() {
        angular.isDefined(this._count) && this.$rootScope.$broadcast(this.CHAT_UNREAD_COUNT_UPDATED_EVENT, {count: this._count});
    },

    _init: function() {
        return this.$q.all(
            [
                this._initUnreadCountFromApi(),
                this._chatSvc.ensureIsStarted()
            ]
        ).then(this._listen.bind(this));
    },

    _initUnreadCountFromApi: function() {
        if (bbw.userIsLocked) {
            this._count = 0;
            return this.$q.when();
        }
        var contacts = this._chatSvc.getContactsModel();
        return contacts.initUnreadCountFromApi().then(function() {
            this._count = contacts.getUnreadCount();
            this._emit();
        }.bind(this));
    },

    _listen: function() {
        if (bbw.userIsLocked) {
            this._count = 0;
            return this.$q.when();
        }
        this._chatSvc.onMessageTotalUnreadCountUpdate(function(event, args) {
            if (this._timeoutPromise) {
                this.$timeout.cancel(this._timeoutPromise);
            }
            this._timeoutPromise = this.$timeout(function() {
                this._count = args.count;
                this._emit();
            }.bind(this), args.count ? 300 : 0);
        }.bind(this));
    }

});